<template>    
    <keep-alive>        
        <component 
            :is="mainform"
            :formdata="formdata"  
            v-on:submitcomplete="onSubmitComplete"
        ></component>
    </keep-alive>
</template>
<script>
    import { mapGetters } from 'vuex';
    import mainform from "../components/forms/MainForm.vue";
    export default {   
    
    props: [
        
    ],
    components: {
        mainform:"mainform"
    },
    data() {
        return {  
            mainform:mainform,
                    
        }
    },
    computed: {
        ...mapGetters({
            formdata: 'adresses/formdata',
            adresses: 'adresses/adresses'
        }),
    },
    methods: {
        onSubmitComplete: function(submitted, id){   
                                    
            if(!submitted) {
                this.$router.push({ 
                name: 'adresses'})
                
            } else {
                this.$router.push({ 
                name: 'adresses_update', 
                params: { 
                        id: id 
                }})
            }
        }
    },
    mounted() {
        
        this.$store.dispatch('adresses/getAll')
        
    }
    
    
}
</script>